var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "logo" },
    [
      _c("router-link", { attrs: { to: "/" } }, [
        _vm.mode === "light"
          ? _c("img", {
              attrs: {
                src: _vm.mediaServer(
                  "/static/brand-img/" +
                    _vm.brandKey +
                    "/logo-" +
                    _vm.nameProp +
                    "white.png"
                ),
                alt: _vm.brandKey
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.mode === "dark"
          ? _c("img", {
              attrs: {
                src: _vm.mediaServer(
                  "/static/brand-img/" +
                    _vm.brandKey +
                    "/logo-" +
                    _vm.nameProp +
                    "dark.png"
                ),
                alt: _vm.brandKey
              }
            })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25c9dbe2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25c9dbe2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Logo.vue
// module id = null
// module chunks = 